module.exports = __webpack_public_path__ + "img/niu1.fbb50374.png";